import { render, staticRenderFns } from "./MFA.vue?vue&type=template&id=347b9ab4&scoped=true"
import script from "./MFA.vue?vue&type=script&lang=ts"
export * from "./MFA.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347b9ab4",
  null
  
)

export default component.exports